"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SKELETON_ANIMATION_DURATION = exports.SKELETON_ANIMATION_DELAY = exports.NIGHT_WORD_FORMS = exports.NDASHS = exports.NBSP = exports.INSTANT_CONFIRM_HINT_TEXT = exports.HOT_PRICE_HINT_TEXT = exports.DATE_FULL_DATE = exports.DATE_FORMAT_WITH_DAY_OF_WEEK = exports.DATE_FORMAT_CLIENT = void 0;
var _localization = require("@lt/localization");
/**
 * дата в формате 02.01.2019
 */
var DATE_FORMAT_CLIENT = exports.DATE_FORMAT_CLIENT = 'dd.MM.yyyy';

/**
 * дата в формате 28 мая, пт
 */
var DATE_FORMAT_WITH_DAY_OF_WEEK = exports.DATE_FORMAT_WITH_DAY_OF_WEEK = 'd MMM, EEEEEE';

/**
 * дата в формате 2 янв 2019 в 12:50
 */
var DATE_FULL_DATE = exports.DATE_FULL_DATE = 'd MMM yyyy в HH:mm';
var HOT_PRICE_HINT_TEXT = exports.HOT_PRICE_HINT_TEXT = _localization.i18n.t('hotel.offer.hotPrice');
var INSTANT_CONFIRM_HINT_TEXT = exports.INSTANT_CONFIRM_HINT_TEXT = _localization.i18n.t('hotel.offer.instant');
var SKELETON_ANIMATION_DELAY = exports.SKELETON_ANIMATION_DELAY = 300; // ms
var SKELETON_ANIMATION_DURATION = exports.SKELETON_ANIMATION_DURATION = 1200; // ms

var NBSP = exports.NBSP = String.fromCharCode(160);
var NDASHS = exports.NDASHS = '-';
var NIGHT_WORD_FORMS = exports.NIGHT_WORD_FORMS = [_localization.i18n.t('hotel.offer.night', {
  count: 0
}), _localization.i18n.t('hotel.offer.night', {
  count: 1
}), _localization.i18n.t('hotel.offer.night', {
  count: 2
})];